module.exports = __webpack_public_path__ + "img/mp-rank-item__img-7.00362532.jpg";